import { Component, computed } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { VehicleLinkCardComponent } from 'app/modules/admin/vehicles/components/vehicle-link-card/vehicle-link-card.component';
import { DateRangePillComponent } from 'app/shared/components/date-range-pill/date-range-pill.component';
import { ExpiresAtPillComponent } from 'app/shared/components/expires-at-pill/expires-at-pill.component';
import { SummaryBriefComponent } from 'shared/components/summary-brief/summary-brief.component';
import { SummaryItemComponent } from 'shared/components/summary-item/summary-item.component';

import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { GetTranslationKeyForValuePipe } from '../../../../../../shared/components/dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { ModuleSelectorComponent } from '../../../../../../shared/components/module-selector/module-selector.component';
import { GetIconFromOptionsPipe } from '../../../../../../shared/pipes/get-icon-from-options.pipe';
import { VehicleRoadTaxRecordModel } from '../../../models/vehicle-road-tax-record.model';
import { ROAD_TAX_RECORD_CATEGORIES } from '../../../translations/vehicle-road-taxes-select-items';

@Component({
	selector: 'app-vehicle-road-taxes-summary',
	templateUrl: 'vehicle-road-taxes-summary.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		VehicleLinkCardComponent,
		ExpiresAtPillComponent,
		DateRangePillComponent,
		SummaryItemComponent,
		SummaryBriefComponent,
		GetIconFromOptionsPipe,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
		ModuleSelectorComponent,
	],
})
export class VehicleRoadTaxesSummaryComponent extends BaseSummarySectionComponent<VehicleRoadTaxRecordModel> {
	protected _skipCount: number = 0;
	recordCategories = ROAD_TAX_RECORD_CATEGORIES;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	isoDateFrom = computed(() =>
		new Date(this.recordData().startsAt).toISOString(),
	);
	isoDateTo = computed(() => new Date(this.recordData().endsAt).toISOString());

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<VehicleRoadTaxRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
